import { render, staticRenderFns } from "./project-selection-dialog.component.vue?vue&type=template&id=32e7d28e"
import script from "./project-selection-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./project-selection-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e7d28e')) {
      api.createRecord('32e7d28e', component.options)
    } else {
      api.reload('32e7d28e', component.options)
    }
    module.hot.accept("./project-selection-dialog.component.vue?vue&type=template&id=32e7d28e", function () {
      api.rerender('32e7d28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/project-selection-dialog/project-selection-dialog.component.vue"
export default component.exports